import moment from 'moment-timezone';
moment.tz.setDefault('America/Denver');
module.exports = moment;


// WEBPACK FOOTER //
// ./portal-components/momentWithZone/index.js